const getCartRows = (lineItems, currency) => {
  return lineItems.map((lineItem) => {
    let productId = "";
    let sku = "";
    switch (lineItem.__typename) {
      case "LineItemContactLenses":
      case "LineItemRegular":
        productId = lineItem.legacyProduct.id;
        sku = lineItem.legacyProduct.sku;
        break;
      case "LineItemBundle":
        const mainBundleItem = lineItem.bundleLineItems.find(
          ({ isMainBundleLineItem }) => isMainBundleLineItem
        );
        productId = mainBundleItem?.legacyProduct.id || "";
        sku = mainBundleItem?.legacyProduct.sku || "";
        break;
    }
    return {
      productId,
      unitPrice: `${lineItem.price.unit.gross / 100}`,
      quantity: lineItem.quantity,
      currency,
      sku
    };
  });
};
export {
  getCartRows
};
//# sourceMappingURL=get-cart-rows.js.map
